import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentFailure = () => {
    const navigate = useNavigate();

    const handleRetry = () => {
        navigate('/pricing'); // or wherever your payment page is
    };

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div style={{ padding: '40px', textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
            <div style={{ marginBottom: '30px' }}>
                <div style={{ fontSize: '48px', color: '#e74c3c', marginBottom: '20px' }}>✗</div>
                <h1 style={{ color: '#e74c3c' }}>Payment Failed</h1>
                <p style={{ fontSize: '18px', color: '#666' }}>
                    We couldn't process your payment. Please try again.
                </p>
            </div>

            <div style={{ 
                backgroundColor: '#fff5f5', 
                padding: '20px', 
                borderRadius: '8px', 
                marginBottom: '30px',
                border: '1px solid #fed7d7'
            }}>
                <h3 style={{ color: '#c53030', marginBottom: '15px' }}>What happened?</h3>
                <ul style={{ textAlign: 'left', color: '#666' }}>
                    <li>Your payment was cancelled or declined</li>
                    <li>There might be insufficient funds in your account</li>
                    <li>Your card details might be incorrect</li>
                    <li>You chose to cancel the payment process</li>
                </ul>
            </div>

            <div style={{ marginTop: '30px' }}>
                <button 
                    onClick={handleRetry}
                    style={{
                        padding: '15px 30px',
                        fontSize: '16px',
                        backgroundColor: '#3498db',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        marginRight: '15px'
                    }}
                >
                    Try Again
                </button>
                
                <button 
                    onClick={handleGoHome}
                    style={{
                        padding: '15px 30px',
                        fontSize: '16px',
                        backgroundColor: 'transparent',
                        color: '#666',
                        border: '2px solid #ddd',
                        borderRadius: '6px',
                        cursor: 'pointer'
                    }}
                >
                    Go to Home
                </button>
            </div>

            <div style={{ marginTop: '40px', fontSize: '14px', color: '#888' }}>
                <p>Need help? Contact our support team at support@yourapp.com</p>
            </div>
        </div>
    );
};

export default PaymentFailure;
